<template>
  <div class="table-page-wrapper">
    <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
      <el-tab-pane label="商品管理" name="first">
        <place-commodity/>
      </el-tab-pane>

      <el-tab-pane label="直播管理" name="two">
        <place-live/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import PlaceCommodity from './commodity.vue'
import PlaceLive from './live.vue'

export default {
  name: 'place',
  components: {
    PlaceLive,
    PlaceCommodity
  },
  data () {
    return {
      activeName: 'first'
    }
  },
  methods: {
    handleClick () {

    }
  }
}
</script>

<style scoped lang="scss">
.el-tabs__header {
  padding: 15px 15px 5px;
  background: #ffffff;
}

</style>
